import React from 'react'

// import Score from '../Score'
import Button from '../Button'

// import { maxSecond } from 'constants/params'
// import results from 'constants/results'
import SocialShare from 'lib/share'

import classes from './styles'

class Result extends React.Component {
  constructor(props) {
    super(props)

    window.ga('send', 'event', 'Показы', 'Экран', 'Финальный экран_Пикчер')
  }

  render() {
    const { currentQuestionIndex, timer, questions, reset, score } = this.props

    const rightAnswerCount = questions.filter(question => question.isAnswerCorrect).length

    // const result = results[Math.floor(Math.random() * results.length)]
    const shareTitle = 'Я полминуты был пикчером Лайфхакера!'
    const shareMessage = `Подобрал обложек: ${rightAnswerCount}`
    const share = new SocialShare(shareTitle, shareMessage)

    function shareOnTwitter() {
      return "https://twitter.com/share?url=10years.lifehacker.ru/picturer/&text="
        + shareTitle + ' ' + shareMessage + ' https://10years.lifehacker.ru/picturer/'
    }

    return (
      <div className={[classes.result, 'result'].join(' ')}>
        <h3>
          Есть такая профессия - картинки подбирать.
        </h3>

        <div>
          <div className={classes.scoreLabel}>
            Ваш счет
          </div>

          <h1 className={classes.score}>
            {score}
          </h1>
        </div>

        <div>
          <Button
            onClick={reset}
          >
            Еще раз
          </Button>
        </div>


        <div className={classes.sharedBlock}>
          <div className={classes.sharingTitle}>
            Рассказать друзьям:
          </div>

          <div>
            <img
              onClick={() => share.vk()}
              className={classes.share}
              src={`${process.env.PUBLIC_URL}/vk.svg`}
              alt=""
            />

            <img
              onClick={() => share.fb()}
              className={classes.share}
              src={`${process.env.PUBLIC_URL}/fb.svg`}
              alt=""
            />

            <img
              onClick={() => share.tw()}
              className={classes.share}
              src={`${process.env.PUBLIC_URL}/twitter.svg`}
              alt=""
            />
          </div>
        </div>

      </div>    )
  }
}

Result.propTypes = {
  currentQuestionIndex: React.PropTypes.number.isRequired,
  timer: React.PropTypes.number.isRequired,
  questions: React.PropTypes.array.isRequired,
  reset: React.PropTypes.func.isRequired,
}

export default Result


// WEBPACK FOOTER //
// ./src/components/Result/Result.jsx